import React from "react";
import { useForm } from "react-hook-form";
import { FAQ } from "../../../types";
import { FaqFormProps, FaqFormData } from "../types/faq-types";
import { ControlledTextField } from "../../../components/form";
import { ControlledTextarea } from "../../../components/form";
import { validateFaqData } from "../utils/faq-utils";

export const FaqForm: React.FC<FaqFormProps> = ({
  onSubmit,
  initialValues,
  isLoading = false,
}) => {
  const form = useForm<FaqFormData>({
    defaultValues: {
      question: initialValues?.question || "",
      answer: initialValues?.answer || "",
    },
  });

  const handleFormSubmit = async (data: FaqFormData): Promise<void> => {
    // Validate form data
    const validation = validateFaqData(data);
    if (!validation.isValid) {
      console.error("Validation errors:", validation.errors);
      return;
    }

    const faqData: Partial<FAQ> = {
      question: data.question.trim(),
      answer: data.answer.trim(),
    };
    await onSubmit(faqData);
  };

  return (
    <form
      onSubmit={form.handleSubmit(handleFormSubmit)}
      className="form-space-y-2"
    >
      <ControlledTextField
        control={form.control}
        name="question"
        label="Вопрос"
        placeholder="Введите вопрос"
        required
        disabled={isLoading}
        minLength={5}
        maxLength={500}
      />

      <ControlledTextarea
        control={form.control}
        name="answer"
        label="Ответ"
        placeholder="Введите ответ"
        required
        disabled={isLoading}
        rows={6}
        minLength={10}
        maxLength={2000}
      />

      <div className="form-wrapper__actions">
        <button
          type="submit"
          className="form-button form-button--primary form-button--full"
          disabled={isLoading || !form.formState.isValid}
        >
          {isLoading
            ? "Загрузка..."
            : initialValues
            ? "Сохранить изменения"
            : "Добавить FAQ"}
        </button>
      </div>
    </form>
  );
};
